import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskedLines = ({ lines, as: Tag = "h1", className = "", lineClassName = "", delay = 0 }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block will-change-transform ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.28em] text-cyan-400 ${className}`}>
    {children}
  </p>
);

export const VoltButton = ({ children, className = "", variant = "primary", ...props }) => {
  const base =
    "group relative inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 font-display text-sm font-semibold tracking-wide transition-all duration-300";
  const styles =
    variant === "primary"
      ? "bg-gradient-to-r from-cyan-400 via-sky-400 to-blue-600 text-white hover:shadow-[0_0_36px_rgba(56,189,248,0.45)] hover:-translate-y-0.5"
      : "border border-cyan-400/30 bg-cyan-400/5 text-cyan-300 hover:border-cyan-400/70 hover:bg-cyan-400/10 hover:text-cyan-200";
  return (
    <button className={`${base} ${styles} ${className}`} {...props}>
      {children}
    </button>
  );
};
